import {css} from "lit-element/lit-element.js";
export default css`
.loading-container {
  text-align: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL3RtcC9iaWdfdmlzaW9uL2JpZ192aXNpb24vdG9vbHMvbGl0X2RlbW8vc3JjL2NvbXBvbmVudHMiLCJzb3VyY2VzIjpbImxpdC1kZW1vLWFwcC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIubG9hZGluZy1jb250YWluZXIge1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG4iXX0= */`;
